import React, { Component } from "react";
import EducationCard from "../education/EducationCard";

class EducationSection extends Component {
  render() {
    return (
      <section
        className="resume-section p-3 p-lg-5 d-flex align-items-center"
        id="education"
      >
        <div className="w-100">
          <h2 className="mb-5">Education</h2>
          <EducationCard
            title="BSc (Hons) in Information Technology Specializing in
            Software Engineering"
            uni="Sri Lanka Institute of Information Technology - Malabe"
            due="Feb 2020 - Feb 2024"
          />
          <EducationCard
            title="Diploma in Software Engineering"
            uni="Esoft Metro Campus - Ambalangoda"
            due="August 2018 - Feb 2019"
          />
          <EducationCard
            title="Advanced Certificate English Course"
            uni="NIBM - Galle"
            due="Desc 2022 - April 2023"
          />
          <EducationCard
            title="Information & Technology Certification Course"
            uni="Open Univercity of Sri Lanka"
            due="Nov 2019 - May 2020"
          />
        </div>
      </section>
    );
  }
}

export default EducationSection;
